import { render } from "./IconDownload.vue?vue&type=template&id=5d6be01c"
import script from "./IconDownload.vue?vue&type=script&lang=js"
export * from "./IconDownload.vue?vue&type=script&lang=js"
script.render = render

export default script